<section id="invoices">
    <div class="main-content pt-0 m-2 px-0 shadow-none">
        <div class="container-fluid px-0">
            <div class="row g-0">
                <div class="col-lg-4 col-md-4 col-sm-4 col-xs-6">
                    <div class="email-send-blk">
                        <mat-card class="shadow">
                            <h4>
                                Send Via Email
                            </h4>
                            <div class="email-list-container">
                                <form [formGroup]="sendEmailForm" (ngSubmit)="onSendEmail()">
                                    <div class="form-inner content-details-blk">
                                        <div class="row">
                            
                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <h4 class="form-item-label mb-0" translate>
                                    Retailer Email
                                    <span class="required">*</span>
                                </h4>
                                <div class="form-item-input">
                                <mat-form-field appearance="outline" class="w-100">
                                    <input
                                    type="email"
                                    aria-label="retailerEmail"
                                    matInput
                                    placeholder="Enter Retailer Email"
                                    [formControl]="retailerEmailCtrl"
                                    [matAutocomplete]="auto"
                                    />
                            <mat-autocomplete
                                #auto="matAutocomplete"
                                (optionSelected)="selectedRetailerDetails($event.option.value)"
                            >
                                <mat-option
                                *ngFor="let option of filteredOptions | async"
                                [value]="option.email"
                                >
                                {{ option.email }}
                                </mat-option>
                            </mat-autocomplete>
                                <div *ngIf="sendEmailForm.controls.retailerEmail.touched && sendEmailForm.controls.retailerEmail.invalid">
                                <div *ngIf="sendEmailForm.controls.retailerEmail.errors.required">
                                    <mat-hint class="text-danger ms-2">
                                    Email Is Required.</mat-hint
                                    >
                                </div>
                                </div>
                                </mat-form-field>
                                </div>
                                </div>
                            </div>
                                    </div>
                                    <div class="email-form-footer text-center">
                                        <ul class="list-inline">
                                            <li class="list-inline-item">
                                                <button mat-flat-button color="primary">Send</button>
                                            </li>
                                            <li class="list-inline-item">
                                                <button mat-stroked-button type="button" (click)="onCancel()"  color="primary"><span translate class="translate">pages.newRetailer.cancel</span></button>

                                            </li>
                                        </ul>
                                    </div>
                                </form>
                            </div>
                        </mat-card>
                    </div>
                </div>
            <div class="col-lg-8 col-md-8 col-sm-8 col-xs-6">
                <div class="invoice-preview-blk
                ">
                    <div class="invoice-holder shadow">
                        <pdf-viewer [src]="dataLocalUrl" class="my-3"
                                    [original-size]="false"
                        ></pdf-viewer>
                    </div>
                </div>
                </div>
            </div>
        </div>
    </div>
</section>